( function( $ ) {

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/

    /*custom scroll*/
    $(window).on("load",function(){

        $('.js-customScroll').mCustomScrollbar({
            callbacks:{
                onCreate:function(){
                    var rail = $(this).find('.mCSB_draggerRail');
                    var container = $(this).find('.mCSB_draggerContainer');
                    container.append(rail);
                }
            }
        });

        $('.js-customCatScroll').mCustomScrollbar({
            axis: "x",
            callbacks:{
                onCreate:function(){
                    var rail = $(this).find('.mCSB_draggerRail');
                    var container = $(this).find('.mCSB_draggerContainer');
                    container.append(rail);
                }
            }
        });

        $('.js-customBcScroll').mCustomScrollbar({
            axis: "x",
            callbacks:{
                onCreate:function(){
                    var rail = $(this).find('.mCSB_draggerRail');
                    var container = $(this).find('.mCSB_draggerContainer');
                    container.append(rail);
                }
            }
        });

    });
    /*custom scroll*/

    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });

    $('.js-hMenu li.menu-item-has-children').hover(function(e){
        if ($(window).width() >= 1200) {
            const subMenu = $(this).children('.sub-menu');
            if (e.type === 'mouseenter') {
                subMenu.stop(true, true).fadeIn(200);
            } else if (e.type === 'mouseleave') {
                subMenu.stop(true, true).fadeOut(200);
            }
        }
    });
    $('.js-hMenu .js-hMenuArr').click(function(e){
        if ($(window).width() < 1200) {
            $(this).closest('li.menu-item-has-children').toggleClass('active');
            $(this).siblings('.sub-menu').slideToggle();
        }
    })

    $('.js-hMenuBtn').click(function(){
        $(this).closest('.header').toggleClass('m-back');
        $(this).toggleClass('active');
        $('.js-hMenu').stop(true, true).fadeToggle(200);
    });

    function closeMobMenu() {
        $('.js-hMenuBtn').removeClass('active');
        $('.js-header').removeClass('m-back');
        $('.js-hMenu').stop(true, true).fadeOut(200);
    }

    // mobile menu: anchor click on the current page closes the menu and scrolls to the target
    $('.js-hMenu').on('click', 'a[href*="#"]', function (e) {
        if ($(window).width() >= 1200) return;
        var url;
        try {
            url = new URL(this.href, window.location.href);
        } catch (err) {
            return;
        }
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        if (!url.hash || url.hash === '#') return;
        var target = document.querySelector(url.hash);
        if (!target) return;
        closeMobMenu();
        // 992-1199: Lenis is active and smooth-scroll.js handles the scroll itself
        if (window.lenis) return;
        e.preventDefault();
        var header = document.querySelector('.js-header');
        var offset = (header ? header.offsetHeight : 0) + 16;
        window.scrollTo({ top: $(target).offset().top - offset, behavior: 'smooth' });
    });


    /*header*/

    /*main*/




    /*first*/
    $(document).ready(function () {
        setTimeout(function(){
            var $target = $('.js-mainFirst');
            var targetBottom = 94;

            $(window).on('scroll resize', function () {
                if ($(window).scrollTop() >= targetBottom) {
                    $target.addClass('active');
                } else {
                    $target.removeClass('active');
                }
            });
        }, 500)
    });
    /*first*/

    /*video*/
    $(document).ready(function () {
        var iframe = $('#vimeo-player')[0];
        if (!iframe) {
            return;
        }
        var vid = String($(iframe).data('vid') || '').trim();
        if (vid === '') {
            return;
        }
        var base = 'https://player.vimeo.com/video/' + vid;

        // On mobile the hero video must NOT autoplay: load a paused embed (shows the
        // poster frame) with our own centered play button overlay; a tap starts it with sound.
        if (window.matchMedia('(max-width: 991px)').matches) {
            iframe.src = base + '?loop=1&autopause=0';
            var $card = $(iframe).closest('.main-first-vid').addClass('is-paused');
            $card.on('click', '.js-heroVidPlay', function () {
                iframe.src = base + '?autoplay=1&loop=1&autopause=0';
                $card.removeClass('is-paused');
            });
            return;
        }

        // Desktop: silent background autoplay (muted, looping, no controls).
        iframe.src = base + '?autoplay=1&loop=1&background=1&autopause=0&muted=1';

        if (typeof Vimeo === 'undefined') {
            return;
        }
        var player = new Vimeo.Player(iframe);
        player.getVolume().then(function (volume) {
            player.setVolume(0);
        });

        function toggleSound(_this) {
            player.getVolume().then(function (volume) {
                _this.find('.sound').removeClass('active');
                if (volume > 0) {
                    player.setVolume(0);
                    _this.find('.sound[data-sound="disabled"]').addClass('active');
                } else {
                    player.setVolume(1);
                    _this.find('.sound[data-sound="enabled"]').addClass('active');
                }
            });
        }

        $('.js-secondLoud').on('click', function () {
            toggleSound($(this));
        });
    });

    /*hero badges reveal*/
    if (typeof gsap !== 'undefined' && $('.main-first-badge').length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        gsap.from('.main-first-badge', {
            autoAlpha: 0,
            y: 24,
            scale: 0.9,
            duration: 0.7,
            ease: 'power2.out',
            stagger: 0.18,
            delay: 0.5
        });
    }
    /*hero badges reveal*/

    /*philosophie reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-philo').length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        gsap.from('.main-philo-head', {
            autoAlpha: 0,
            y: 30,
            duration: 0.7,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: '.main-philo',
                start: 'top 78%'
            }
        });
        gsap.from('.main-philo-card', {
            autoAlpha: 0,
            x: -90,
            y: 16,
            rotate: -2,
            duration: 0.9,
            ease: 'back.out(1.2)',
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.main-philo-cards',
                start: 'top 82%'
            }
        });
    }
    /*philosophie reveal*/

    /*equipe reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-equipe').length) {
        var mmEquipe = gsap.matchMedia();
        mmEquipe.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.from('.main-equipe-head', {
                autoAlpha: 0,
                y: 30,
                duration: 0.7,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.main-equipe',
                    start: 'top 78%'
                }
            });
            var tlEquipe = gsap.timeline({
                scrollTrigger: {
                    trigger: '.main-equipe-data',
                    start: 'top 72%'
                }
            });
            tlEquipe
                .from('.main-equipe-art', { autoAlpha: 0, duration: 0.6, ease: 'power1.out' })
                .from('.main-equipe-bl--center', { autoAlpha: 0, y: 70, scale: 0.94, duration: 0.7, ease: 'power2.out' }, '-=0.3')
                .from('.main-equipe-bl--left', { autoAlpha: 0, x: -180, duration: 0.8, ease: 'power3.out' }, '-=0.2')
                .from('.main-equipe-bl--right', { autoAlpha: 0, x: 180, duration: 0.8, ease: 'power3.out' }, '<');
        });
    }
    /*equipe reveal*/

    /*mots reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-mots').length) {
        var mmMots = gsap.matchMedia();
        mmMots.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.from('.main-mots-head', {
                autoAlpha: 0,
                y: 30,
                duration: 0.7,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.main-mots',
                    start: 'top 78%'
                }
            });
            var tlMots = gsap.timeline({
                scrollTrigger: {
                    trigger: '.main-mots-body',
                    start: 'top 72%'
                }
            });
            tlMots
                .from('.main-mots-img', { autoAlpha: 0, scale: 0.94, duration: 0.7, ease: 'power2.out' })
                .from('.main-mots-col--left .main-mots-item', { autoAlpha: 0, x: -110, duration: 0.7, ease: 'power3.out', stagger: 0.15 }, '-=0.3')
                .from('.main-mots-col--right .main-mots-item', { autoAlpha: 0, x: 110, duration: 0.7, ease: 'power3.out', stagger: 0.15 }, '<')
                .from('.main-mots-arrow', { autoAlpha: 0, duration: 0.5, ease: 'power1.out', stagger: 0.08 }, '-=0.2');
        });
    }
    /*mots reveal*/

    /*espace reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-espace').length) {
        var mmEspace = gsap.matchMedia();
        mmEspace.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.from('.main-espace-ttl', {
                autoAlpha: 0,
                y: 30,
                duration: 0.7,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.main-espace',
                    start: 'top 78%'
                }
            });
            gsap.set('.main-espace-bl', { autoAlpha: 0, y: -32 });
            gsap.to('.main-espace-bl', {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                ease: 'sine.out',
                stagger: 0.25,
                clearProps: 'transform,opacity,visibility',
                scrollTrigger: {
                    trigger: '.main-espace-list',
                    start: 'top 85%'
                }
            });
        });
    }
    /*espace reveal*/

    /*scrolltrigger refresh after late layout shifts (images, embeds)*/
    if (typeof ScrollTrigger !== 'undefined') {
        $(window).on('load', function () {
            ScrollTrigger.refresh();
            setTimeout(function () {
                ScrollTrigger.refresh();
            }, 600);
        });
    }
    /*scrolltrigger refresh*/

    /*acces reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-acces').length) {
        var mmAcces = gsap.matchMedia();
        mmAcces.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.from('.main-acces-ttl', {
                autoAlpha: 0,
                y: 30,
                duration: 0.7,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.main-acces',
                    start: 'top 78%'
                }
            });
            var tlAcces = gsap.timeline({
                scrollTrigger: {
                    trigger: '.main-acces-row',
                    start: 'top 75%'
                }
            });
            tlAcces
                .from('.main-acces-left', { autoAlpha: 0, x: -90, duration: 0.8, ease: 'power3.out' })
                .from('.main-acces-mapcol', { autoAlpha: 0, x: 90, duration: 0.8, ease: 'power3.out' }, '<');
        });
    }
    /*acces reveal*/

    /*form reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-form').length) {
        var mmForm = gsap.matchMedia();
        mmForm.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.from('.main-form-head, .main-form-wrap', {
                autoAlpha: 0,
                y: 40,
                duration: 0.7,
                ease: 'power2.out',
                stagger: 0.15,
                scrollTrigger: {
                    trigger: '.main-form',
                    start: 'top 78%'
                }
            });
        });
    }
    /*form reveal*/

    /*footer city parallax*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.f-dec--city').length) {
        var mmCity = gsap.matchMedia();
        mmCity.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.fromTo('.f-dec--city img', { y: 110 }, {
                y: 0,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.f-dec--city',
                    start: 'top bottom',
                    end: 'bottom 85%',
                    scrub: true
                }
            });
        });
    }
    /*footer city parallax*/

    /*page bottom retour*/
    $(document).on('click', '.js-goBack', function (e) {
        if (window.history.length > 1 && document.referrer && document.referrer.indexOf(window.location.host) !== -1) {
            e.preventDefault();
            window.history.back();
        }
    });
    /*page bottom retour*/

    /*category faq accordion*/
    $(document).on('click', '.js-faqHead', function () {
        var item = $(this).closest('.js-faqItem');
        if (item.hasClass('active')) {
            item.removeClass('active');
            item.find('.js-faqBody').stop(true, true).slideUp(250);
        } else {
            $('.js-faqItem.active').removeClass('active').find('.js-faqBody').stop(true, true).slideUp(250);
            item.addClass('active');
            item.find('.js-faqBody').stop(true, true).slideDown(250);
        }
    });
    /*category faq accordion*/

    /*category parcours steps*/
    $(document).on('click mouseenter', '.js-parcStep', function (e) {
        if (e.type === 'mouseenter' && $(window).width() < 992) return;
        var step = $(this).data('step');
        if ($(this).hasClass('active')) return;
        $('.js-parcStep').removeClass('active');
        $(this).addClass('active');
        $('.js-parcDetail').removeClass('active').hide();
        $('.js-parcDetail[data-step="' + step + '"]').addClass('active').stop(true, true).fadeIn(250);
    });
    /*category parcours steps*/

    /*technologies page video windows*/
    function techVideoSrc(v) {
        v = String(v == null ? '' : v).trim();
        if (v === '') return '';
        if (/^\d+$/.test(v)) {
            return 'https://player.vimeo.com/video/' + v + '?autoplay=1&muted=1&loop=1&autopause=0';
        }
        var m = v.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (m) {
            return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&muted=1&loop=1&autopause=0';
        }
        return v;
    }

    function techOpenVideo(block) {
        var win = block.find('.js-techWin');
        var holder = win.find('.js-techVidHolder');
        var src = techVideoSrc(block.find('.js-techVid').data('video'));
        if (src === '' || win.hasClass('active')) return;
        $('.js-techWin.active').removeClass('active').find('.js-techVidHolder').html('');
        if (/\.(mp4|webm|ogv)(\?|$)/i.test(src)) {
            holder.html($('<video>', { src: src, autoplay: true, muted: true, loop: true, playsinline: true }));
        } else {
            holder.html($('<iframe>', { src: src, allow: 'autoplay; fullscreen', allowfullscreen: true }));
        }
        win.addClass('active').hide().fadeIn(250);
    }

    function techCloseVideo(win) {
        win.fadeOut(200, function () {
            win.removeClass('active').css('display', '');
            win.find('.js-techVidHolder').html('');
        });
    }

    $(document).on('mouseenter', '.js-techVid', function () {
        if ($(window).width() >= 992) {
            techOpenVideo($(this).closest('.js-techBlock'));
        }
    });
    $(document).on('click', '.js-techVid', function () {
        if ($(window).width() < 992) {
            techOpenVideo($(this).closest('.js-techBlock'));
        }
    });
    $(document).on('click', '.js-techCls', function () {
        techCloseVideo($(this).closest('.js-techWin'));
    });
    $(document).on('mouseleave', '.js-techBlock', function () {
        if ($(window).width() >= 992) {
            var win = $(this).find('.js-techWin');
            if (win.hasClass('active')) {
                techCloseVideo(win);
            }
        }
    });
    /*technologies page video windows*/

    /*technologies page reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.tech-page').length) {
        var mmTech = gsap.matchMedia();
        mmTech.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            $('.js-techBlock').each(function () {
                var block = $(this);
                var dir = block.hasClass('tech-block--illo-left') ? -1 : 1;
                var circle = block.find('.tech-block-circle');
                var tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: this,
                        start: 'top 75%'
                    }
                });
                tl.from(block.find('.tech-block-info'), { autoAlpha: 0, x: -70 * dir, duration: 0.8, ease: 'power3.out' })
                    .from(block.find('.tech-block-illo-img'), { autoAlpha: 0, x: 70 * dir, duration: 0.8, ease: 'power3.out' }, '-=0.55');
                if (circle.length) {
                    /* kill the CSS hover transition for the tween, clearProps restores it */
                    tl.set(circle, { transition: 'none' }, '-=0.45')
                        .from(circle, { autoAlpha: 0, scale: 0.55, duration: 0.55, ease: 'back.out(1.7)', clearProps: 'all' }, '<');
                }
            });
        });
    }
    /*technologies page reveal*/

    /*hero video modal*/
    $(document).on('click', '.js-heroPlay', function () {
        var vid = $('.js-heroModal').data('video');
        if (!vid) return;
        var iframe = $('<iframe>', {
            src: 'https://player.vimeo.com/video/' + vid + '?autoplay=1&muted=0&autopause=1',
            allow: 'autoplay; fullscreen',
            allowfullscreen: true
        });
        $('.js-heroModalVid').html(iframe);
        $('.js-heroModal').addClass('active');
    });
    $(document).on('click', '.js-heroModalCls', function () {
        $('.js-heroModal').removeClass('active');
        $('.js-heroModalVid').html('');
    });
    $(document).on('keyup', function (e) {
        if (e.key === 'Escape' && $('.js-heroModal').hasClass('active')) {
            $('.js-heroModal').removeClass('active');
            $('.js-heroModalVid').html('');
        }
    });
    /*hero video modal*/

    /*traits reveal*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-traits').length) {
        var mmTraits = gsap.matchMedia();
        mmTraits.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.from('.main-traits-ttl', {
                autoAlpha: 0,
                y: 30,
                duration: 0.7,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: '.main-traits',
                    start: 'top 78%'
                }
            });
            var tlTraits = gsap.timeline({
                scrollTrigger: {
                    trigger: '.main-traits-row',
                    start: 'top 75%'
                }
            });
            tlTraits
                .from('.main-traits-bl', { autoAlpha: 0, x: -90, duration: 0.7, ease: 'power3.out', stagger: 0.2 })
                .from('.main-traits-imgwrap', { autoAlpha: 0, x: 90, duration: 0.8, ease: 'power3.out' }, '-=0.6');
        });
    }
    /*traits reveal*/

    /*traits*/
    $(document).on("mouseover", ".js-traitsBl", function() {
        if ($(window).width() >= 992) {
            if (!$(this).hasClass("active") && !$(this).closest('.js-traitsBl').hasClass("active")) {
                $('.js-traitsBl').removeClass("active");
                $('.js-traitsBlTxt').stop(true, true).slideUp(250);
                $('.js-traitsImg').stop(true, true).fadeOut(250);
                $('.js-traitsBl[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-traitsBl[data-img="'+$(this).data('img')+'"] .js-traitsBlTxt').stop(true, true).slideDown(250);
                $('.js-traitsImg[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-traitsImg[data-img="'+$(this).data('img')+'"]').stop(true, true).fadeIn(250);
            }
        }
    });

    $(document).on("click", ".js-traitsBl", function(e) {
        if ($(window).width() < 992) {
            if (!$(this).hasClass("active") && !$(this).closest('.js-traitsBl').hasClass("active")) {
                e.preventDefault();
                $('.js-traitsBl').removeClass("active");
                $('.js-traitsBlTxt').stop(true, true).slideUp(250);
                $('.js-traitsImg').stop(true, true).fadeOut(250);
                $('.js-traitsBl[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-traitsBl[data-img="'+$(this).data('img')+'"] .js-traitsBlTxt').stop(true, true).slideDown(250);
                $('.js-traitsImg[data-img="'+$(this).data('img')+'"]').stop(true, true).fadeIn(250);
            }
        }
    });
    /*traits*/

    /*gallery fancybox*/
    if (typeof Fancybox !== 'undefined' && $('[data-fancybox="galerie"]').length) {
        Fancybox.bind('[data-fancybox="galerie"]');
    }
    /*gallery fancybox*/

    /*technologies banner*/
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && $('.main-techs').length) {
        var mmTechs = gsap.matchMedia();
        mmTechs.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
            gsap.fromTo('.js-techsParallax', { yPercent: -10 }, {
                yPercent: 10,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.main-techs',
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
            gsap.fromTo('.js-techsCard', { y: 120 }, {
                y: -70,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.main-techs',
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });
    }
    /*technologies banner*/

    /*documents*/
    $('.js-mainDocsSlider').slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        appendArrows: $('.js-mainDocsSliderArrs'),
        prevArrow: '<button class="arrow left prev-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M31.6663 20H8.33301" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> <path d="M19.9997 31.6666L8.33301 19.9999L19.9997 8.33325" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        nextArrow: '<button class="arrow right next-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.33301 20H31.6663" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20 8.33325L31.6667 19.9999L20 31.6666" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        responsive: [
            {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
            },
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
            }
        ]
    } );
    /*documents*/



    /*page-docs*/
    $('.js-docsTabsTab').click(function(){
        console.log($(this).data('id'))
    })
    /*page-docs*/

    /*page-conseils*/
    $('.js-pageConsVidsSlider').slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        appendArrows: $('.js-pageConsVidsSliderArrs'),
        prevArrow: '<button class="arrow left prev-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M31.6663 20H8.33301" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> <path d="M19.9997 31.6666L8.33301 19.9999L19.9997 8.33325" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        nextArrow: '<button class="arrow right next-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.33301 20H31.6663" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20 8.33325L31.6667 19.9999L20 31.6666" stroke="#758091" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        responsive: [
            {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
            },
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
            }
        ]
    } );

    // The video fields accept a Vimeo id or vimeo.com link (as before) and now a
    // YouTube link too - watch, youtu.be, embed, shorts, live - or a bare id.
    function parseVideoSource(raw) {
        var value = String(raw === undefined || raw === null ? '' : raw).trim();
        if (value === '') {
            return null;
        }
        if (/^[0-9]+$/.test(value)) {
            return { provider: 'vimeo', id: value };
        }
        var vimeo = value.match(/vimeo\.com\/(?:video\/)?([0-9]+)/i);
        if (vimeo) {
            return { provider: 'vimeo', id: vimeo[1] };
        }
        var youtube = value.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i);
        if (youtube) {
            return { provider: 'youtube', id: youtube[1] };
        }
        if (/^[A-Za-z0-9_-]{11}$/.test(value)) {
            return { provider: 'youtube', id: value };
        }
        return null;
    }

    function videoEmbedUrl(source) {
        if (source.provider === 'youtube') {
            return 'https://www.youtube-nocookie.com/embed/' + source.id + '?autoplay=1&rel=0';
        }
        return 'https://player.vimeo.com/video/' + source.id + '?autoplay=1&loop=0&autopause=0&muted=0';
    }

    function setVideoThumb($img, source) {
        if (source.provider === 'youtube') {
            // maxresdefault is missing on older uploads: fall back to hqdefault
            $img.one('error', function () {
                $(this).attr('src', 'https://i.ytimg.com/vi/' + source.id + '/hqdefault.jpg');
            });
            $img.attr('src', 'https://i.ytimg.com/vi/' + source.id + '/maxresdefault.jpg');
            return;
        }
        $.getJSON('https://vimeo.com/api/oembed.json', { url: 'https://vimeo.com/' + source.id }, function (data) {
            var thumbUrl = data.thumbnail_url;
            $img.attr('src', thumbUrl.replace(/-d_\d+x\d+\?/, '-d_640?'));
        });
    }

    $('.js-pageConsVidsBl').each(function(){
        var source = parseVideoSource($(this).data('video'));
        if (source) {
            setVideoThumb($(this).find('.js-pageConsVidsBlImg'), source);
        }
    })
    $('.js-pageConsVidsBl').click(function(){
        var source = parseVideoSource($(this).data('video'));
        if (!source) {
            return;
        }
        var iframe = $('<iframe>', {
            src: videoEmbedUrl(source),
            width: 1600,
            height: 900,
            frameborder: 0,
            allow: 'autoplay; fullscreen',
            allowfullscreen: true
        });
        $('.js-pageConsModalVid').append(iframe);
        $('.js-pageConsModal').addClass('active');
    })
    $('.js-pageConsModalCls').click(function(){
        $('.js-pageConsModal').removeClass('active');
        $('.js-pageConsModalVid').html('');
    });
    /*page-conseils*/

     /*page parcours*/
    $(document).ready(function () {
        var $blocks = $('.js-pageParcBl');
        var currentIndex = -1;
        var ticking = false;

        function updateBlocks() {
            // the card whose center is closest to the viewport center wins.
            // cards have a fixed height, so their positions don't shift when one
            // activates — the active index moves smoothly and monotonically.
            var viewCenter = $(window).scrollTop() + ($(window).height() / 2);
            var activeIndex = 0;
            var minDist = Infinity;

            $blocks.each(function (index) {
                var blockCenter = $(this).offset().top + ($(this).outerHeight() / 2);
                var dist = Math.abs(blockCenter - viewCenter);
                if (dist < minDist) {
                    minDist = dist;
                    activeIndex = index;
                }
            });

            // only touch the DOM when the active card actually changes — avoids
            // re-triggering transitions every scroll tick (source of the jitter)
            if (activeIndex === currentIndex) {
                return;
            }
            currentIndex = activeIndex;

            $blocks.removeClass('active');
            $blocks.eq(activeIndex).addClass('active');
        }

        function onScroll() {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(function () {
                    updateBlocks();
                    ticking = false;
                });
            }
        }

        $(window).on('scroll resize load', onScroll);
        updateBlocks();
    });
     /*page parcours*/



    /*float block*/
    $(window).on('load resize', function(){
        if ($('.js-pageConsFloat').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-pageConsFloat').offset().top;
                var singleSidebarRailTop = $('.js-pageConsFloatRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-pageConsFloat').outerHeight();
                var singleSidebarMenuH = $('.js-pageConsFloatBlock').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-pageConsFloatRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-pageConsFloatRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-pageConsFloatBlock').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-pageConsFloatBlock').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-pageConsFloatBlock').css('top', '0')
                    }
                })
            } else {
                $('.js-pageConsFloatRail').css('height', 'auto')
            }
        }
    })
    /*float block*/

}( jQuery ) );
